import constants from '@/libs/utils/constants'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    filters: {
      search: '',
      status: constants.ticketStatus.Open,
      openedBy: constants.ticketFilter.MyTickets,
      priority: null,
      adminShowAll: false,
      sortBy: 'lastUpdatedOn',
      sortDesc: true,
    },
  },
  getters: {},
  mutations: {
    setFilters(state, filters) {
      state.filters = filters
    },
  },
  actions: {
    SET_FILTERS({ commit }, filters) {
      commit('setFilters', filters)
    },
    GET_TICKETS: (state, { paramsTicket }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get('/api/tickets', { params: paramsTicket })
          .then(res => resolve(res))
          .catch(err => reject(err))
      }),
    GET_TICKET: (state, { id }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(`/api/tickets/${id}`)
          .then(res => resolve(res))
          .catch(err => reject(err))
      }),
    GET_ASSIGNABLE_USERS: (state, params = {}) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get('/api/tickets/assignable-users', { params })
          .then(res => resolve(res))
          .catch(err => reject(err))
      }),
    CREATE_TICKET: (state, { ticket }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post('/api/tickets', ticket)
          .then(res => resolve(res))
          .catch(err => reject(err))
      }),
    UPDATE_TICKET: (state, { id, data }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .patch(`/api/tickets/${id}`, data)
          .then(res => resolve(res))
          .catch(err => reject(err))
      }),
    CREATE_COMMENT: (state, { ticketId, comment }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .post(`/api/tickets/${ticketId}/comments`, comment)
          .then(res => resolve(res))
          .catch(err => reject(err))
      }),
  },
}
